import { isNil } from "lodash";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import { chatMessageGroupByChannelIdSelectors } from "../chatMessage/chatMessageSlice";
import type { RocketchatResponseHandler } from "../RocketchatResponseHandler";
import { store } from "../redux/store";
import { readMessageEventThunk } from "./chatEventThunk";
import { retrieveTargetsForReadUpdate } from "./retrieveTargetsForReadUpdate";

export const handleReadMessageEventHandler: RocketchatResponseHandler = ({
  response,
}) => {
  const readMessage = response?.read_message;

  if (isNil(readMessage)) {
    console.error("readMessageEventHandler: readMessage is nil");
    return;
  }

  const messages = chatMessageGroupByChannelIdSelectors(
    store.getState().chatMessage,
  )[readMessage.channel_id];

  if (isNil(messages)) {
    console.error("readMessageEventHandler: messages is nil");
    return;
  }

  const isContainsReadMessage = messages.some(
    (message) => message.id === readMessage.message_id,
  );
  const readerId = readMessage.reader?.id;

  if (!isContainsReadMessage || isNil(readerId)) {
    return;
  }

  const updateTargets: ChatMessage[] = retrieveTargetsForReadUpdate({
    messages,
    readerId,
    readMessageId: readMessage.message_id,
  });

  store.dispatch(
    readMessageEventThunk({
      chatMessages: updateTargets,
    }),
  );
};
